import { render, staticRenderFns } from "./TheImage.vue?vue&type=template&id=3937ccf8&scoped=true&"
import script from "./TheImage.vue?vue&type=script&lang=js&"
export * from "./TheImage.vue?vue&type=script&lang=js&"
import style0 from "./TheImage.vue?vue&type=style&index=0&id=3937ccf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937ccf8",
  null
  
)

export default component.exports